import { render, staticRenderFns } from "./FooterComponentBfz.vue?vue&type=template&id=b08a4f54"
import script from "./FooterComponentBfz.vue?vue&type=script&lang=ts"
export * from "./FooterComponentBfz.vue?vue&type=script&lang=ts"
import style0 from "./FooterComponentBfz.vue?vue&type=style&index=0&id=b08a4f54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports